import {
  validatePresence,
  validateLength,
} from 'ember-changeset-validations/validators';
import { validateUniqueness } from 'uplisting-frontend/validators/unique';
import { customMessageValidator } from 'uplisting-frontend/validators/custom-message';

export const CustomMessageTagValidation = {
  name: [
    validatePresence({ presence: true }),
    customMessageValidator('unique_custom_message_tag', validateUniqueness()),
  ],

  description: [validatePresence({ presence: true })],

  content: [
    customMessageValidator(
      'custom_message_tag_content',
      validatePresence({
        presence: true,
      }),
    ),
  ],

  channels: [validateLength({ min: 1, allowNone: false })],
};
